import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	footerContainer: {
		display         : "flex",
		justifyContent  : "center",
		alignItems      : "center",
		padding         : "2rem",
		backgroundColor : theme.other.colors.background.tertiary
	}
} ) );
